import { z } from 'zod';
import { definePath } from '../../router/definePath';

export const FunkeTvDigitalPaths = {
  start: definePath('public', { de: '/kampagnen/tv-digital', en: '/campaigns/tv-digital' }),
  participationTerms: definePath('public', {
    de: '/kampagnen/tv-digital/teilnahmebedingungen',
    en: '/campaigns/tv-digital/participation-terms',
  }),
} as const;

// getTranslatedPathnames.ts requires each export here to be a flat Record<string, DefinedPath>.
export const WmQuizPaths = {
  start: definePath('public', { de: '/kampagnen/wm-quiz', en: '/campaigns/wm-quiz' }),
  participationTerms: definePath('public', {
    de: '/kampagnen/wm-quiz/teilnahmebedingungen',
    en: '/campaigns/wm-quiz/participation-terms',
  }),
  /** Pre-/campaigns URLs, kept for old bookmarks and QR codes. */
  legacyStart: definePath('public', { de: '/wm-quiz', en: '/wm-quiz' }),
  legacyParticipationTerms: definePath('public', {
    de: '/wm-quiz/teilnahmebedingungen',
    en: '/wm-quiz/participation-terms',
  }),
} as const;

// `.optional()` before `.catch`: the catch value (`undefined`) must itself be a valid output of the
// schema it follows, and a bare `z.literal` doesn't accept `undefined`. `.catch` then also absorbs a
// garbage value the same way it absorbs a missing key. Forgeable and read-only: it only selects a
// landing page in `loadBirthdayContestDestination`, nothing else.
// `from`, not `context` or `source`: `context` is the entry-context system's own word (see
// `EntryContextDeclaration`), and `source` reads as real attribution (`sc_source`/`utm_source`).
const birthdayContestLandingSearch = z.object({
  from: z.literal('confirm-email').optional().catch(undefined),
});

export const BirthdayContestPaths = {
  /** The virtual page: renders nothing, forwards to one of three external landing pages. */
  landing: definePath(
    'bare',
    { de: '/kampagnen/geburtstags-gewinnspiel', en: '/campaigns/birthday-contest' },
    { search: birthdayContestLandingSearch },
  ),
} as const;
